import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDownload = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M14.34 10.0732V10.1599C14.34 13.1399 13.1467 14.3332 10.1667 14.3332H5.82665C2.84665 14.3332 1.65332 13.1399 1.65332 10.1599V10.0732",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "path-2-inside-1_91_9304",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M10.6668 9L8.00016 11.6667L5.3335 9" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.081 10.4142C12.8621 9.63317 12.8621 8.36683 12.081 7.58579C11.3 6.80474 10.0337 6.80474 9.25262 7.58579L12.081 10.4142ZM8.00016 11.6667L6.58595 13.0809C7.367 13.8619 8.63333 13.8619 9.41438 13.0809L8.00016 11.6667ZM6.74771 7.58579C5.96666 6.80474 4.70033 6.80474 3.91928 7.58579C3.13823 8.36683 3.13823 9.63317 3.91928 10.4142L6.74771 7.58579ZM9.25262 7.58579L6.58595 10.2525L9.41438 13.0809L12.081 10.4142L9.25262 7.58579ZM9.41438 10.2525L6.74771 7.58579L3.91928 10.4142L6.58595 13.0809L9.41438 10.2525Z",
			fill: "currentColor",
			mask: "url(#path-2-inside-1_91_9304)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 3C8 5.8 8 8.83333 8 10",
			stroke: "currentColor",
			strokeWidth: 2,
			strokeLinecap: "round"
		})
	]
});
export default SvgDownload;
